import { createScope as r } from "../../dom-query/dist/index.mjs";
import { createAnatomy as i } from "../../anatomy/dist/index.mjs";
var g = i("toast").parts(
  "group",
  "root",
  "title",
  "description",
  "actionTrigger",
  "closeTrigger"
);
g.build();
var o = r({
  getRegionId: (t) => `toast-group:${t}`,
  getRegionEl: (t, e) => o.getById(t, `toast-group:${e}`),
  getRootId: (t) => `toast:${t.id}`,
  getRootEl: (t) => o.getById(t, o.getRootId(t)),
  getTitleId: (t) => `toast:${t.id}:title`,
  getDescriptionId: (t) => `toast:${t.id}:description`,
  getCloseTriggerId: (t) => `toast${t.id}:close`
});
export {
  g as anatomy
};
